import React from 'react';
import UnitItemErrorRecordListContainer from './UnitItemErrorRecordListContainer';
import Card from '../../../../core/layout/Card';

const UnitItemErrorRecordScene = () => (
  <div>
    <Card title="Unit Items Errors Reports">
      <UnitItemErrorRecordListContainer />
    </Card>
  </div>
);

export default UnitItemErrorRecordScene;
